module.exports = __webpack_public_path__ + "fonts/Chivo-BlackItalic.c5d7be9.woff2";